import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import type { PluginProps } from 'ricos-types';

import { Component } from './unsupported-blocks-component';

export const UnsupportedBlock: React.FC<PluginProps> = () => {
  const { t } = useContext(RicosContext);
  return (
    <div contentEditable={false}>
      <Component t={t} />
    </div>
  );
};
